import React from 'react';
import AccountMenu from './AccountMenu';
import Breadcrumb from './Breadcrumb';
import './DashboardHeader.css';

interface Badge {
  label: string;
  variant: 'primary' | 'secondary';
}

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface DashboardHeaderProps {
  title: string;
  subtitle?: string | React.ReactNode;
  badges?: Badge[];
  breadcrumbs?: BreadcrumbItem[];
  showBackButton?: boolean;
  onBack?: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title,
  subtitle,
  badges = [],
  breadcrumbs = [],
  showBackButton = false,
  onBack
}) => {
  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="header-left">
          <div className="header-logos">
            <img
              src="/img/gravely_new.svg"
              alt="Gravely"
              className="header-logo gravely-logo"
            />
            <img
              src="/img/ariens.svg"
              alt="Ariens"
              className="header-logo ariens-logo"
            />
          </div>
          <div className="header-title-section">
            <h1 className="header-title">{title}</h1>
            {subtitle && (
              <div className="header-subtitle">
                {typeof subtitle === 'string' ? (
                  <span className="manager-name">{subtitle}</span>
                ) : (
                  subtitle
                )}
              </div>
            )}
            {badges.length > 0 && (
              <div className="header-badges">
                {badges.map((badge, i) => (
                  <span key={i} className={`header-badge ${badge.variant}`}>
                    {badge.label}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="header-right">
          {breadcrumbs.length > 0 && (
            <div className="header-breadcrumb">
              <Breadcrumb items={breadcrumbs} />
            </div>
          )}
          <AccountMenu />
          {showBackButton && onBack && (
            <button onClick={onBack} className="back-button">
              <i className="material-icons">arrow_back</i>
              Back
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
